import { forwardRef, useState } from "react"
import { MessageSquare, Loader2 } from "lucide-react"

/**
 * Chat-Bar unter dem Split-View.
 * User gibt Anweisung ein ("kuerzer", "duzen", "andere Uhrzeit") → Enter = regenerate.
 */
export const ClaudeChatBar = forwardRef<HTMLInputElement, {
  onRegenerate: (prompt: string) => void
  pending: boolean
  onCmdK?: () => void
}>(function ClaudeChatBar({ onRegenerate, pending }, ref) {
  const [value, setValue] = useState("")

  const submit = () => {
    const v = value.trim()
    if (!v || pending) return
    onRegenerate(v)
    setValue("")
  }

  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 8,
      background: "#FAFAF8", border: "0.5px solid rgba(44,44,42,0.15)",
      borderRadius: 8, padding: "8px 12px",
    }}>
      {pending ? (
        <Loader2 size={14} style={{ color: "#3C3489", animation: "spin 1s linear infinite" }} />
      ) : (
        <MessageSquare size={14} style={{ color: "#3C3489" }} />
      )}
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") { e.preventDefault(); submit() }
        }}
        placeholder={pending ? "Claude denkt nach…" : "Claude fragen: 'kuerzer', 'duzen', 'andere Uhrzeit vorschlagen'…"}
        disabled={pending}
        style={{
          flex: 1, border: "none", outline: "none", background: "transparent",
          fontSize: 13, color: "#2C2C2A",
        }}
      />
      <kbd style={{
        fontSize: 12, fontFamily: "ui-monospace, monospace", color: "#888780",
        background: "#fff", border: "0.5px solid rgba(44,44,42,0.15)",
        padding: "2px 6px", borderRadius: 4,
      }}>⌘K</kbd>
    </div>
  )
})
